<template>
  <div class="row">
    <div class="col-12">
      <code v-if="debug">
        {{ data }}
        <hr />
        {{ model }}
      </code>
     
      <div>
        <b-form-group label="Group" :disabled="false">

          <v-select
            v-model="model.AirlineIcaoCode"
            :options="menuAirlines"
            :reduce="(e) => e.AirlineIcaoCode"
            label="AirlineIcaoCode"
          >
          </v-select>

        </b-form-group>
      </div>

     

      <div>
        <b-form-group label="Location" :disabled="false">
          <v-select
            v-model="model.LocationAreaId"
            :options="locationAreas"
            :reduce="(e) => e.LocationAreaId"
          >
            <template
              v-slot:option="{AirportCode, TerminalCode, TerminalArea}"
            >
              Airport: {{ AirportCode }} | Terminal: {{ TerminalCode }} |
              Terminal Area: {{ TerminalArea }}
            </template>
            <template v-slot:selected-option-container>
              <div class="vs__selected">
                Airport: {{ locationAreasLabel.AirportCode }} | Terminal:
                {{ locationAreasLabel.TerminalCode }} | Terminal Area:
                {{ locationAreasLabel.TerminalArea }}
              </div>
            </template>
          </v-select>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Handler" :disabled="false">
          <v-select
            v-model="model.HandlerCode"
            :options="handlers"
            :reduce="(e) => e.HandlerCode"
            label="HandlerCode"
          >
          </v-select>
        </b-form-group>
      </div>
    </div>
    <hr />
    <div class="col-12 bt-1">
      <b-button variant="success" class="mr-1" @click="save">Save</b-button>
      <b-button variant="success" @click="saveAndClose"
        >Save &amp; Close</b-button
      >
      <b-button variant="secondary" class="ml-1" @click="cancel">Cancel</b-button>
    </div>

    
  </div>
</template>

<script>
import NotificationMixin from '@mixins/notificationMixin.js'
import CancelMixin from '@mixins/cancel.js'
export default {
  mixins: [NotificationMixin, CancelMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    contentType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debug: false,
      boolsSwitches: {
        CheckInEnabled: false,
        BagTagPrintingEnabled: false,
      },
      model: {
        MenuAirlineGroupId: null,
        AirlineIcaoCode: null,
        LocationAreaId: null,
        HandlerCode: null,
      },
    }
  },
  computed: {
    menuAirlines() {
      return this.$store.getters['MenuAirlines/list']
    },
    airlineGroups() {
      return this.$store.getters['AirlineGroup/list']
    },
    handlers() {
      return this.$store.getters['Handlers/list']
    },
    locationAreas() {
      return this.$store.getters['LocationAreas/list']
    },
    locationAreasLabel() {
      return this.locationAreas.find(
        (e) => e.LocationAreaId === this.model.LocationAreaId
      )
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
        if (data) this.mapData(data)
      },
    },
    boolsSwitches: {
      deep: true,
      handler(bools) {
        // The server model uses T/F rather than bools!
        this.model.CheckInEnabled = bools.CheckInEnabled ? 'T' : 'F'
        this.model.BagTagPrintingEnabled = bools.BagTagPrintingEnabled
          ? 'T'
          : 'F'
      },
    },
  },

  beforeCreate() {
    // Get dependency data
    const depData = ['LocationAreas', 'Handlers', 'AirlineGroup']
    depData.forEach((key) => {
      this.$store.dispatch(`${key}/all`)
    })
  },
  methods: {
    mapData(dataIn) {
      //   Take the server data and apply it to our model
      this.model.MenuAirlineGroupId = dataIn.MenuAirlineGroupId
      this.model.AirlineIcaoCode = dataIn.AirlineIcaoCode
      this.model.LocationAreaId = dataIn.LocationAreaId
      this.model.HandlerCode = dataIn.HandlerCode
    },
    async save() {
      if (this.saveDisabled) {
        return
      }
      let id, type
      if (this.data) {
        id = this.data[this.contentType.idKey]
        type = 'patch'
      } else {
        id = 0
        type = 'post'
      }
      try {
        this.model.AirlineIcaoCode = this.model.AirlineIcaoCode.toUpperCase();
        await this.$store.dispatch(`${this.contentType.name}/${type}`, {
          id: id,
          body: this.model,
        })
        this.showNotification('Saved successfully', 'success')
      } catch (error) {
        this.showNotification(error, 'error')

        throw new Error(error)
      }
    },
    async saveAndClose() {
      if (this.saveDisabled) {
        return
      }
      try {
        await this.save()
      } catch (error) {
        window.console.log(error)
        return
      }
      this.$router.push(`/${this.contentType.name}/list`)
    },
  },
}
</script>
